import logo from './logo.svg';
import './App.css';
import PuzzleWebsite from './PuzzleWebsite';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <PuzzleWebsite />
      </header>
    </div>
  );
}

export default App;
